export default __webpack_public_path__ + "static/wamo_mobile750-b6cd01a960f17bc44c035dda3334b4f1.mp4";